"use client";

import { DebugScreenSize } from "@/components/debugScreenSize";
import { useHasPermission } from "@/hooks/usePermissions";
import { useHomePmViewStore } from "@/store/useHomePmViewStore";
import { useUserStore } from "@/store/userStore";

import { AviList } from "./aviList";
import { HomeAviPanel } from "./homeAviPanel";
import { HomeProjectsPanel } from "./homeProjectsPanel";
import { ProjectList } from "./projectList";

export function HomePage() {
  const permissionsInitialized = useUserStore((s) => s.permissionsInitialized);
  const canViewProjects = useHasPermission("panel:projects");
  const canViewAvi = useHasPermission("panel:avi");
  const pmView = useHomePmViewStore((s) => s.view);

  const showAviList = !canViewProjects || (canViewAvi && pmView === "avis");

  if (!permissionsInitialized) return null;
  if (!canViewProjects && !canViewAvi) return null;

  return (
    <div className="flex h-full min-h-0 flex-1 items-stretch justify-center gap-2 bg-(--surface-background) py-2 pr-2 pl-0">
      <DebugScreenSize />
      {canViewProjects ? <HomeProjectsPanel /> : <HomeAviPanel />}
      {showAviList ? <AviList /> : <ProjectList />}
    </div>
  );
}
